<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import appConfig from "@/app.config";
    import moment from 'moment';

    export default {
        page: {
            title: "Tv Show Report",
            meta: [
                {
                name: "description",
                content: appConfig.description,
                },
            ],
        },
        components: { Layout, PageHeader },
        data() {
            const current_date = moment().format("YYYY-MM-DD");
            return {
                title: "Tv Show Report",
                items: [
                {
                    text: "Tv Show Report",
                    active: true,
                },                   
                ],

                earnings: [],   
                tv_shows: [],         
                
                pagination: {},

                doctors: [],
                clinics: [],
                agencies: [],

                clinic_id: "",
                agency_id: "",
                doctor_id: "",
                
                from_date: current_date,
                to_date: current_date,
                keyword: "",
                listing_length: 10,
                status: '',
                token: "",
                errors: {},          
                active_page_url: null,
            };
        },
        mounted() {
            this.clearLocalStorage();

        },

        created() 
        {
            this.fetchDoctors();
            this.fetchAgencies();
            this.fetchClinics();
            this.fetchTvShowReport();
        },

        methods: 
        {
            clearLocalStorage() {
                localStorage.removeItem("consultation_filters");
                localStorage.removeItem("cancel_consultation_filters");
                localStorage.removeItem("patient_filters");
                localStorage.removeItem("doctor_filters");

            },
            fetchDoctors() {
                let url = "api/admin/getDoctors";         
                this.getToken();
                this.$axios
                    .get(url, { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.doctors = responseData.doctors;
                    })
                    .catch((err) => console.log(err));
            },

            fetchClinics() {
                let url = "api/admin/getClinics";         
                this.getToken();
                this.$axios
                    .get(url, { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.clinics = responseData.clinics;
                    })
                    .catch((err) => console.log(err));
            },

            fetchAgencies() {
                let url = "api/admin/getAgencies";         
                this.getToken();
                this.$axios
                    .get(url, { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.agencies = responseData.agencies;
                    })
                    .catch((err) => console.log(err));
            },
            clearForm() {
               this.errors = {};  
            }, 
            fetchTvShowReport(page_url = null) 
            {
                this.getToken();
                let url = "api/admin/tvShowReport?&limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&clinic_id=" + this.clinic_id + "&doctor_id=" + this.doctor_id + "&agency_id=" + this.agency_id;

                page_url = page_url || url;

                if(localStorage.back_url) {
                    page_url = localStorage.back_url;  
                    localStorage.removeItem('back_url');
                }    

                this.active_page_url = page_url;
                this.loading = true;

                this.$axios
                    .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    this.tv_shows = responseData.tv_shows.data;
                    
                    this.pagination = responseData.tv_shows.links;
                    this.from = responseData.tv_shows.from;
                    this.to = responseData.tv_shows.to;
                    this.total = responseData.tv_shows.total;
                    this.clearForm();
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            if(typeof error.response.data.message === 'object') {
                                this.errors = error.response.data.message;
                                console.log(error.response.status);
                            } else {
                                this.$swal("", error.response.data.message, "error");
                            }                        
                            
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            }, 

            downloadReport()
            {
                let url = "api/admin/tvShowReportPdf?&limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&clinic_id=" + this.clinic_id + "&doctor_id=" + this.doctor_id + "&agency_id=" + this.agency_id;
                this.getToken();
                    this.loading = true;
                    this.$axios
                    .get(url, {
                            headers: { Authorization: "Bearer " + this.token },
                            responseType: "blob" 
                    })
                    .then((res) => {
                            const blob = new Blob([res.data], { type: "application/pdf" });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = "Tv_Show_report.pdf"; 
                            link.click();
                            window.URL.revokeObjectURL(url);
                    })
                    .catch((error) => {
                        console.error("Error downloading PDF file:", error);
                        const reader = new FileReader();
                        reader.onload = (event) => {
                            const text = event.target.result;
                            const errorData = JSON.parse(text);
                            const errorMessage = errorData.message;
                            if(errorMessage){
                                this.errors = errorMessage;
                            }else{
                            this.$swal("", "Failed to download PDF file", "error");
                            }
                        };
                        reader.readAsText(error.response.data);
                    })
            },

            downloadTvShowExcel() 
            {
                let url = "api/admin/tvShowReportExcel?&limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&clinic_id=" + this.clinic_id + "&doctor_id=" + this.doctor_id + "&agency_id=" + this.agency_id;
                this.getToken();
                this.loading = true;
                this.$axios
                .get(url, {
                        headers: { Authorization: "Bearer " + this.token },
                        responseType: "blob" // Specify blob response type
                })
                .then((res) => {
                        const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = "Tv_show_report.xlsx";
                        link.click();
                        window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error("Error downloading PDF file:", error);
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        const text = event.target.result;
                        const errorData = JSON.parse(text);
                        const errorMessage = errorData.message;
                        if(errorMessage){
                            this.errors = errorMessage;
                        }else{
                        this.$swal("", "Failed to download PDF file", "error");
                        }
                    };
                    reader.readAsText(error.response.data);
                })
            },


            getToken() {
                if (localStorage.getItem('medicino_admin')) {
                var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                if(medicino_admin.token) {
                    this.token = medicino_admin.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
                
                } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
                }
            }, 

        }
    }
</script>
    
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">

                <div class="card">
                <div class="card-body">
                    <!----- filters area starts---->
                    <div class="row mb-3">
                        <div class="form-group col-lg-4">
                            <label>From Date <span class="text-danger">*</span></label>
                            <b-form-input type="date" v-model="from_date" v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }"></b-form-input>
                            <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                            </div>
                        </div>
                        
                        <div class="form-group col-lg-4">
                            <label>To Date <span class="text-danger">*</span></label>
                            <b-form-input type="date" v-model="to_date" v-bind:class="{ 'is-invalid': Boolean(errors.to_date) }"></b-form-input>
                            <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                            </div>
                        </div>
                        
                        <div class="form-group col-lg-3">
                            <label class="control-label">Agency </label>
                            <select class="form-control" v-model="agency_id" >
                                <option value="">Select</option>
                                <option :value="agency.id" v-for="agency in agencies" :key="agency.id"> {{agency.name}}</option>
                            </select> 
                        </div>

                        <div class="form-group col-lg-3">
                            <label>Doctor</label>
                            <select class="form-control" v-model="doctor_id" >
                                <option value="">All Doctors</option>
                                <option :value="doctor.id" v-for="doctor in doctors" :key="doctor.id">{{doctor.name}}</option>
                            </select>
                        </div>

                        <div class="form-group col-lg-3">
                            <label>Clinic</label>
                            <select class="form-control" v-model="clinic_id" >
                                <option value="">All Clinic</option>
                                <option :value="clinic.id" v-for="clinic in clinics" :key="clinic.id">{{clinic.name}}</option>
                            </select>
                        </div>
                        
                    </div>
                    <!----- filters area ends---->

                    <div class="row">
                        <div class="col-12">
                            <button class="btn btn-primary me-2" type="button" @click="fetchTvShowReport()">View</button>
                            <button class="btn btn-primary me-2" type="button" @click="downloadReport()">Download PDF</button>
                            <button class="btn btn-primary me-2" type="button" @click="downloadTvShowExcel()">Download Excel</button>
                        </div>
                    </div>
                </div>
                </div>
                <div class="card">
                <div class="card-body">
                    <!----- Listing length and search starts ----->
                    <div class="row mb-3">
                        <div class="col-sm-12 col-md-6">
                            <div class="listing-length" >
                            <label
                                >Show
                                <select class="form-control" v-model="listing_length" @click="fetchTvShowReport()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                </select>
                                entries
                            </label>
                            </div>                        
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="listing-filter">
                            <label>
                                <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchTvShowReport()"/>
                            </label>
                            </div>                     
                            
                        </div>
                    </div>
                    <!----- Listing length and search ends ----->

                    <!---- listing table starts -------->
                    <div class="table-responsive">
                        <table class="table table-bordered mb-0">
                            <thead class="table-light">
                            <tr>
                                <th>Show Id</th>
                                <th>Show Name</th>  
                                <th>Agency</th> 
                                <th>Tv Name</th> 
                                <th>Clinic</th>
                                <th>Doctor</th>
                                <th>Total Slot Usage</th>
                            </tr>
                            </thead>
                            <tbody v-if="tv_shows.length >0">
                            <tr v-for="tv_show in tv_shows" :key="tv_show">
                                <td>{{tv_show.id}}</td>                       
                                <td>{{tv_show.title}}</td>
                                <td>{{tv_show.agency}}</td>
                                <td>{{tv_show.tv_name}}</td>
                                <td>{{tv_show.clinic_name}}</td>
                                <td>{{tv_show.dr_code}} {{tv_show.dr_name}}</td>
                                <td>{{tv_show.total_slot_usage}}</td>
                            </tr>
                    
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="8" class="text-center">No Shows  found</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <!---- listing table ends -------->

                    <!----pagination starts --->     
                    <caption v-if="Boolean(tv_shows.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                    <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                        <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                            <a href="#" class="page-link" @click.prevent="fetchTvShowReport(page.url + '&limit='+ listing_length + '&from_date='+ from_date + '&to_date=' + to_date + '&keyword=' + keyword+ '&clinic_id='+ clinic_id + '&agency_id=' + agency_id + '&doctor_id=' + doctor_id)">
                            <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                            <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                            <span v-else>{{page.label}}</span>                          
                            </a>
                        </li>
                    </ul>
                    <!----pagination ends --->


                </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
